import { motion } from 'framer-motion';

const opacitySeries = [0.8, 0.4, 0.8];

export const LoadingMedium = () => {
    return (
        <div className="flex items-center justify-center">
            <div className="relative w-[120vw] h-[120vw] max-w-[800px] max-h-[800px]">

                {/* Outer circle */}
                <motion.div
                    className="absolute -inset-2 rounded-full bg-osPink-5"
                    animate={{
                        scale: [1, 1.3, 1],
                        opacity: opacitySeries,
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                />

                {/* Middle circle */}
                <motion.div
                    className="absolute inset-8 rounded-full bg-osPink-4"
                    animate={{
                        scale: [1, 1.25, 1],
                        opacity: opacitySeries,
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.3,
                    }}
                />

                {/* Inner circle */}
                <motion.div
                    className="absolute inset-20 rounded-full bg-osPink-3"
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: opacitySeries,
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.6,
                    }}
                />

                {/* Core circle */}
                <motion.div
                    className="absolute inset-30 rounded-full bg-osPink-2"
                    animate={{
                        scale: [1, 1.15, 1],
                        opacity: opacitySeries,
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.9,
                    }}
                />
            </div>
        </div>
    );
};